import React from 'react';

const Tabs = ({ tabs, activeTab, onChange, className = '' }) => {
  return (
    <div className={`flex bg-[#F9F9F9] p-1 rounded-full ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onChange(tab)}
          className={`
            flex-1 px-6 py-3 rounded-full font-semibold transition-all
            ${activeTab === tab 
              ? 'bg-[#0C1D40] text-white' 
              : 'text-gray-600 hover:text-[#0C1D40]'
            }
          `}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;